<template>
  <v-card>

    <v-card-title>
      <slot name="title"></slot>
    </v-card-title>

    <v-card-text>
      <v-data-table :headers="headers" :items="items" :loading="loading" :options.sync="options" :footer-props="{itemsPerPageOptions}" class="body--text" v-bind="optsAttr">

        <template v-slot:item.last_changed="{ item }">
          {{ item.last_changed | formatDate('YYYY-MM-DD HH:mm Z') }}       
        </template>

        <template v-slot:item.event="{ item }">
          {{ item.event | customPlaceholder(' ') }}
        </template>

        <template v-slot:item.event_detail="{ item }">
          {{ item.event_detail | customPlaceholder(' ') }}
        </template>

        <template v-slot:item.previous_value="{ item }">
          {{ item.previous_value | customPlaceholder(' ') }}
        </template>

        <template v-slot:item.new_value="{ item }">
          {{ item.new_value | customPlaceholder(' ') }}
        </template>

      </v-data-table>
    </v-card-text>

  </v-card>
</template>

<script>
  export default {
    props: {
      items: {
        type: Array,
        default: () => ([])
      },

      loading: {
        type: Boolean,
        default: false
      },

      reset: {
        type: Boolean,
        default: false
      },

      serverItemsLength: {
        type: Number,
        default: 0,
      }      
    },

    data() {
      return {
        headers: [
          {text: 'Timestamp', align: 'left', sortable: false, value: 'last_changed'},
          {text: 'Event', align: 'left', sortable: false, value: 'event'},
          {text: 'Event Detail', align: 'left', sortable: false, value: 'event_detail'},
          {text: 'Previous Value', align: 'left', sortable: false, value: 'previous_value'},
          {text: 'New Value', align: 'left', sortable: false, value: 'new_value'},
          {text: 'User', align: 'left', sortable: false, value: 'user'},
        ],
        options: {
          itemsPerPage: 10,
          page: 1
        },
        itemsPerPageOptions: [5,10,25,50]
      }
    },

    computed: {
      optsAttr() {
        const attributes = {};
        if(this.serverItemsLength) {
          attributes['server-items-length'] = this.serverItemsLength;
        }
        return attributes;
      }
    },

    watch: {
      options: {
        immediate: false,
        handler() {
          if (!this.reset) {
            this.$emit('updatePagination', this.options);
          }
        },
        deep: true,
      },

      reset: {
        handler(val) {
          if (val) {
            this.options.itemsPerPage = 10;
            this.options.page = 1;
          }
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
</style>